import { render, staticRenderFns } from "./XPlatformIcon.vue?vue&type=template&id=2a98acac&scoped=true"
import script from "./XPlatformIcon.vue?vue&type=script&lang=js"
export * from "./XPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98acac",
  null
  
)

export default component.exports